import React, {useEffect, useRef, useState} from 'react';
import './styles.css';

const Slider = (props) => {
    const {
        step,
        min,
        max,
        value,
        defaultLength,
        onChangeValue,
        linearGradientColor,
        linearGradientColorGrad,
        rangeBackgroundColor,
        currency,
    } = props;

    const rangeRef = useRef();
    const [range, setRange] = useState(defaultLength);

    useEffect(() => {
        const rangeValue = parseInt(rangeRef.current.value, 10);
        rangeLinearGradient(rangeValue, min, max);
    }, [rangeRef, min, max]);

    useEffect(() => {
        const numberValue = Number(value)
        onChangeValue(numberValue > 100000 ? 100000 : numberValue);
        setRange(numberValue);
        rangeLinearGradient(numberValue, min, max);
    }, [value])

    const handleChange = max => e => {
        onChangeValue(e.target.value);
        setRange(e.target.value);
        rangeLinearGradient(e.target.value, min, max);
    }

    const calculatePercentage = (value, min, max) => {
        return ((value - min) / (max - min)) * 100 + '%';
    }

    const rangeLinearGradient = (value, min, max) => {
        const percentage = calculatePercentage(value, min, max);
        rangeRef.current.style.background = `linear-gradient(90deg, ${linearGradientColor}, ${linearGradientColorGrad} ${percentage} 0%, ${rangeBackgroundColor} ${percentage} 100%)`;
        rangeRef.current.nextSibling.style.left = percentage
    }

    function toCommaString(num) {
        let arr = [];

        while (num > 1000) {
            let n = num % 1000;
            let s = '';
            if (n < 100) s = '0';
            if (n < 10) s = '00';
            arr.unshift(s + n);
            num = Math.floor(num / 1000);
        }
        arr.unshift(num.toString());
        return arr.join();
    }

    return (
        <>
            <div className="slider">
                <div className="slider-wrapper">
                    <div className="">
                        <div style={{padding: "0 85px", flex: "1 0"}}>
                            <div className="slider">

                                <input
                                    ref={rangeRef}
                                    className={`range-slider`}
                                    type="range"
                                    step={step}
                                    min={min}
                                    max={max}
                                    value={value}
                                    onChange={handleChange(max)}
                                />

                                <div className={`range-slider-value`}>
                                    {currency === true
                                        ? `${toCommaString(range)} km`
                                        : `${toCommaString(range)} miles`
                                    }
                                </div>
                            </div>

                        </div>
                        <div className="slider-grid">
                            {currency === true
                                ? <div className="slider-grid-text">100 km grid</div>
                                : <div className="slider-grid-text">100 miles grid</div>
                            }
                            {currency === true
                                ? <div className="slider-grid-text">100,000 km grid</div>
                                : <div className="slider-grid-text">100,000 miles grid</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Slider;